// 2026-11-04 (Keaton: "if the user hasn't clicked a scene and just plays, it should play through the whole video with
// all the sounds in a pre-mixed form, even if not final render quality"): the player's Play rough cut (api
// v4/roughcut.ts: free, cached, built from what the video already has).
import { isAdProject } from "./formats";
import type { Project } from "./types";

/** A rough cut needs a video's script (an ad has none: its voiceover is one read across every scene). */
export function canRoughCut(p: Pick<Project, "script" | "format">): boolean {
  return !isAdProject(p) && !!p.script?.scenes?.length;
}

/** The quiet note under the player for the silent lines ("Silent where scene 2's line isn't recorded yet."). */
export function roughCutNote(missing: string[]): string | null {
  const m = missing.filter((x) => x.trim());
  if (!m.length) return null;
  if (m.length > 3) return `Silent in ${m.length} scenes: their lines aren't recorded yet.`;
  const list = m.length === 1 ? m[0]! : `${m.slice(0, -1).join(", ")} and ${m.at(-1)}`;
  return `Silent where ${list}.`;
}
